import React from 'react';
import { Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

export default function FieldDTO(props) {
  const {
    dtoObject,
    labelKey,
    namePrefix = '',
    labelPrefix = '',
    additionalValidators = [],
    inputProps = {},
    control,
    component: Componet = null,
    transform = {
      output: e => e,
      input: v => v,
    },
  } = props;
  const { formatMessage } = useIntl();

  if (!Componet) { return null; }
  let name = 'not-found-dto';
  let dtoLabelKey = 'not-found-dto';
  let dtoValidators = [];
  if (!dtoObject || !dtoObject.labelKey) {
    // throw new Error('Dto object not found');
    window.console.error('Dto object not found');
  } else {
    name = dtoObject.name;
    dtoLabelKey = dtoObject.labelKey;
    dtoValidators = dtoObject.validators;
  }

  if (namePrefix) {
    name = `${namePrefix}${name}`;
  }

  const validators = {
    ...dtoValidators,
    ...additionalValidators,
  };
  const label = labelPrefix + (labelKey || dtoLabelKey);
  return (
    <Controller
      defaultValue=""
      name={name}
      control={control}
      rules={{ validate: { ...validators } }}
      render={({
        field,
        fieldState,
        formState,
      }) => {
        const { onChange, value, ...fieldData } = field;
        const change = e => field.onChange(transform.output(e));
        const v = transform.input(field.value);
        return (
          (
            <Componet
              fieldState={fieldState}
              formState={formState}
              label={formatMessage({ id: label })}
              placeholder={formatMessage({ id: `${label}.placeholder`, defaultMessage: ' ' })}
              inputProps={{
                ...fieldData, ...inputProps, onChange: change, value: v,
              }}
              {...props}
            />
          )
        );
      }}
    />
  );
}
